import React, { useCallback, useEffect, useState } from 'react'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import { CircularProgress, useTheme, Tooltip } from '@material-ui/core'


import { Page, Header, CustomTable } from 'components'
import { useCasoService } from 'hooks/useCasoService'
import useRouter from 'utils/useRouter'
import { useStyles } from './MeusCasos.styles'

export const MeusCasos = (props) => {
  const { route } = props
  moment.locale('pt-br', localization)
  const classes = useStyles()
  const theme = useTheme()
  const router = useRouter()
  const casoService = useCasoService()

  const [meusCasos, setMeusCasos] = useState([])
  const [processando, setProcessando] = useState(true)

  const buscarMeusCasos = useCallback(async () => {
    setProcessando(true)
    try {
      const dados = await casoService.listarMeusCasosAsync()
      setMeusCasos(dados || [])
    } catch (error) {
      console.error('Erro ao buscar meus casos:', error)
    } finally {
      setProcessando(false)
    }
  }, [])

  useEffect(() => {
    buscarMeusCasos()
  }, [buscarMeusCasos])

  const handleRowClick = (id) => {
    router.history.push(`/casos/caso/detalhar/${id}`)
  }

  const colunas = [
    {
      title: 'Identificador',
      field: 'identificador',
      cellStyle: { fontWeight: 600, width: '15%', minWidth: '120px' },
    },
    {
      title: 'Descrição',
      field: 'descricao',
      cellStyle: { minWidth: '250px' },
      render: (rowData) => (
        <Tooltip title={rowData.descricao || 'Sem descrição'} arrow placement="top-start">
          <div
            style={{
              maxWidth: '380px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              color: theme.palette.text.secondary,
            }}
          >
            {rowData.descricao || 'Sem descrição registrada'}
          </div>
        </Tooltip>
      ),
    },
    {
      title: 'Órgão responsável',
      field: 'setRes.nome',
      render: (rowData) => rowData.setRes?.nome?.toUpperCase() || '-',
      cellStyle: { minWidth: '180px' },
    },
    {
      title: 'Data',
      field: 'data',
      type: 'date',
      defaultSort: 'desc',
      render: (rowData) => moment(rowData.data || rowData.createdAt).format('DD/MM/YYYY HH:mm'),
      cellStyle: { width: '15%', minWidth: '160px' },
    },
  ]

  return (
    <Page className={classes.root} title={`${route.secao} - SIGEP`}>
      <Header titulo={`${route.secao} cadastrados`} overline={route.secao} />

      {processando ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <CustomTable
          columns={colunas}
          data={meusCasos}
          onRowClick={(event, rowData) => handleRowClick(rowData.id)}
          searchPlaceholder="Buscar casos..."
          emptyDataSourceMessage="Nenhum caso encontrado"
        />
      )}
    </Page>
  )
}
